import React from 'react';
import { cn } from '../../../lib/utils';
import { OrkaPriorityChip } from '../OrkaPriorityChip';
import { OrkaStatePill } from '../OrkaStatePill';
import { OrkaText } from '../OrkaText';

/**
 * OrkaTaskIdentityStrip — keeps task identity visible during edit (PRD §5.2).
 *
 * Used at the top of TaskModal / TaskDetailDrawer so the user always sees the
 * canonical identity of the task being edited, even when the form below is
 * collapsed or scrolled.
 *
 *   <OrkaTaskIdentityStrip task={t} />
 */
export function OrkaTaskIdentityStrip({ task, className, ...rest }) {
  if (!task) return null;
  const title = task.title || task.task_title || 'Untitled';
  const projectColor = task.project_color_hex || task.work_area_color || '#475569';

  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-lg border orka-border-subtle px-3 py-2',
        className,
      )}
      style={{
        backgroundImage: `linear-gradient(to right, ${projectColor}1A, transparent 60%)`,
      }}
      {...rest}
    >
      <span
        aria-hidden="true"
        className="shrink-0 rounded-full"
        style={{ width: 4, height: 28, backgroundColor: projectColor }}
      />
      <div className="min-w-0 flex-1">
        <OrkaText size="micro" variant="tertiary" as="div" className="truncate">
          {task.work_area_name || task.category || 'Workspace'}
        </OrkaText>
        <OrkaText size="body" variant="primary" truncate as="div" className="font-semibold">
          {title}
        </OrkaText>
      </div>
      <OrkaPriorityChip priority={task.task_priority ?? task.priority} size="sm" />
      <OrkaStatePill state={task.task_status || task.state} size="sm" />
    </div>
  );
}

export default OrkaTaskIdentityStrip;
